enum SessionIneligibilityReason {
  Unknown = "Unknown",
  BalanceDueNotZero = "BalanceDueNotZero",
  DocumentNotSupported = "DocumentNotSupported",
  NotProcessable = "NotProcessable",
  SessionIsFinalised = "SessionIsFinalised",
}

export function SessionIneligibilityReasonFromApi(
  message: string
): SessionIneligibilityReason {
  if (message === "balance due is not zero") {
    return SessionIneligibilityReason.BalanceDueNotZero;
  }
  if (message === "document not supported") {
    return SessionIneligibilityReason.DocumentNotSupported;
  }

  return SessionIneligibilityReason.Unknown;
}

export default SessionIneligibilityReason;
